

// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { FiHeart, FiHome, FiShoppingCart, FiUser, FiSearch } from "react-icons/fi";
// import { motion } from "framer-motion";
// import { useCart } from "../App";
// import logo from "../assests/logo/Havbit6.png";


// export default function Header() {
//   const { cart = [], wishlist = [] } = useCart();
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isCategoryBarVisible, setIsCategoryBarVisible] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const navigate = useNavigate();
//   const location = useLocation();
  
//   const headerRef = useRef(null);

//   const isAccountPage = location.pathname === "/account";
//   const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
//   const isProductDetailPage = location.pathname.startsWith("/product/");
  
//   const FALLBACK_CATEGORIES = [
//     { _id: '69328e258ec00e5b1605beae', name: 'Bars & Bites', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766751846/products/fuujrigaubpxfuqhs2x5.png' },
//     { _id: '693291818ec00e5b1605bed2', name: 'Dry Fruits & Nuts', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766751985/products/nyk54xjlnerjgobfdgae.png' },
//     { _id: '693295a48ec00e5b1605bf27', name: 'Superfoods', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752030/products/amcx65vs31ewwizoajyc.png' },
//     { _id: '693296238ec00e5b1605bf2e', name: 'Beverages', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752340/products/nbtpvdcyfffse7xzunqq.png' },
//     { _id: '693296618ec00e5b1605bf31', name: 'Natural Products', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752598/products/v9twecgy8l5chukiw9qw.png' },
//     { _id: '6932a77801f804e9a3267247', name: 'Breakfast Essentials', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752378/products/pmaawk72mvs8ehzsty6r.png' },
//     { _id: '6932a7d501f804e9a326724a', name: 'Combos & Gift Packs', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752496/products/nxbunwjsj8briwudyvpv.png' },
//     { _id: '6932aac901f804e9a326726d', name: 'Immunity & Wellness', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752579/products/qesw0zc598mv00gkwfbs.png' },
//     { _id: '6932c61ac86f55cf811a5920', name: 'Protein Bar', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766751897/products/wdtx575dofasyi7fxcac.png' },
//   ];

//   const cartItemCount = cart.reduce((total, item) => total + (item.qty || 1), 0);
//   const wishlistCount = wishlist.length;

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 50) {
//         setIsCategoryBarVisible(false);
//       } else if (currentScrollY < lastScrollY) {
//         setIsCategoryBarVisible(true);
//       }
//       setLastScrollY(currentScrollY);
//     };
//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch('https://server.havbit.in/api/categories');
//       if (response.ok) {
//         const data = await response.json();
//         setCategories(data);
//       } else {
//         setCategories(FALLBACK_CATEGORIES);
//       }
//       setLoading(false);
//     } catch (error) {
//       setCategories(FALLBACK_CATEGORIES);
//       setLoading(false);
//     }
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (searchQuery.trim()) {
//       navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
//       setSearchQuery("");
//     }
//   };

//   return (
//     <>
//       <header ref={headerRef} className="sticky top-0 z-50 bg-white shadow-sm">
//         <div className="border-b border-gray-100">
//           <div className="container mx-auto px-2 sm:px-4">
//             <div className="flex items-center justify-between h-14 md:h-16">
              
//               {/* Logo Area */}
//               <div className="flex-shrink-0">
//                 <Link to="/" className="flex items-center">
//                   <img src={logo} alt="Havbit" className="h-10 md:h-16 w-auto object-contain" />
//                 </Link>
//               </div>

//               {/* Desktop Search Bar */}
//               <div className="hidden lg:flex flex-1 mx-8">
//                 <form onSubmit={handleSearch} className="relative w-full max-w-xl">
//                   <div className="relative">
//                     <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                     <input
//                       type="text"
//                       placeholder="Search for snacks, nuts, beverages..."
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       className="w-full pl-12 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-red-400 text-sm"
//                     />
//                   </div>
//                 </form>
//               </div>

//               {/* Desktop Icons (Wishlist, Cart, User) */}
//               <div className="hidden lg:flex items-center space-x-3">
//                 <Link to="/wishlist" className="p-2 rounded-full hover:bg-gray-100 relative group">
//                   <FiHeart size={22} className="text-gray-600 group-hover:text-red-400 transition-colors" />
//                   {wishlistCount > 0 && (
//                     <span className="absolute -top-1 -right-1 bg-red-400 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
//                       {wishlistCount}
//                     </span>
//                   )}
//                 </Link>
//                 <Link to="/cart" className="p-2 rounded-full hover:bg-gray-100 relative group">
//                   <FiShoppingCart size={22} className="text-gray-600 group-hover:text-red-400 transition-colors" />
//                   {cartItemCount > 0 && (
//                     <span className="absolute -top-1 -right-1 bg-red-400 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
//                       {cartItemCount}
//                     </span>
//                   )}
//                 </Link>
//                 <Link to="/account" className="p-2 rounded-full hover:bg-gray-100 group">
//                   <FiUser size={22} className="text-gray-600 group-hover:text-red-400" />
//                 </Link>
                
//               </div>

//               {/* Mobile View: Search + Wishlist + Become a Seller (No Cart, No Hamburger) */}
//               <div className="flex lg:hidden items-center space-x-1">
//                 <Link to="/search" className="p-2 text-gray-600 active:text-red-400">
//                   <FiSearch size={20} />
//                 </Link>
                
//                 {/* Wishlist Mobile Pe Rakhi Hai */}
//                 <Link to="/wishlist" className="p-2 text-gray-600 relative active:text-red-400">
//                   <FiHeart size={20} />
//                   {wishlistCount > 0 && (
//                     <span className="absolute top-1 right-1 bg-red-400 text-white text-[8px] font-bold w-3.5 h-3.5 flex items-center justify-center rounded-full">
//                       {wishlistCount}
//                     </span>
//                   )}
//                 </Link>

              
//               </div>

//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Category Scrolling Bar */}
//       {(!isProductDetailPage && !(isMobile && isAccountPage)) && (
//         <motion.div
//           initial={{ y: 0 }}
//           animate={{ y: isCategoryBarVisible ? 0 : -100 }}
//           transition={{ duration: 0.3 }}
//           className="sticky z-40 bg-white shadow-sm border-b border-gray-100"
//           style={{ top: '56px' }}
//         >
//           <div className="container mx-auto px-2">
//             <div className="flex overflow-x-auto scrollbar-hide py-2 gap-2 lg:gap-4 items-center">
//               <button
//                 onClick={() => navigate('/')}
//                 className={`flex-shrink-0 flex flex-col items-center min-w-[50px] lg:min-w-[80px] ${location.pathname === '/' ? 'text-red-400' : 'text-gray-700'}`}
//               >
//                 <FiHome className={`w-5 h-5 mb-1 ${location.pathname === '/' ? 'text-red-400' : 'text-gray-500'}`} />
//                 <span className="text-[10px] lg:text-xs font-medium">Home</span>
//               </button>
              
//               {!loading && categories.map((category) => {
//                   // Check if current URL matches the category ID
//                   const isActive = location.pathname === `/category/${category._id}`;
//                   return (
//                     <button
//                       key={category._id}
//                       onClick={() => navigate(`/category/${category._id}`)}  // Changed: Now using category ID
//                       className={`flex-shrink-0 flex flex-col items-center min-w-[55px] lg:min-w-[80px] ${isActive ? 'text-red-400' : 'text-gray-700'}`}
//                     >
//                       <div className="w-6 h-6 lg:w-7 lg:h-7 mb-1 flex items-center justify-center">
//                         <img 
//                           src={category.image} 
//                           alt={category.name} 
//                           className="max-w-full max-h-full object-contain"
//                           onError={(e) => { 
//                             e.target.src = "https://ui-avatars.com/api/?name=" + category.name + "&background=random";
//                           }}
//                         />
//                       </div>
//                       <span className="text-[10px] lg:text-xs font-medium whitespace-nowrap">
//                         {category.name}
//                       </span>
//                     </button>
//                   );
//               })}
//             </div>
//           </div>
//         </motion.div>
//       )}
//     </>
//   );
// }






























import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FiHeart, FiHome, FiShoppingCart, FiUser, FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import { useCart } from "../App";
import logo from "../assests/logo/Havbit6.png";

export default function Header() {
    const { cart = [], wishlist = [], setSelectedHomeCategory } = useCart();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [isCategoryBarVisible, setIsCategoryBarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  
  const headerRef = useRef(null);

  const isAccountPage = location.pathname === "/account";
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
  const isProductDetailPage = location.pathname.startsWith("/product/");

  // ✅ ONLY ADD THIS LINE
  const isAboutPage = location.pathname === "/about";
  
  const FALLBACK_CATEGORIES = [
    { _id: '69328e258ec00e5b1605beae', name: 'Bars & Bites', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766751846/products/fuujrigaubpxfuqhs2x5.png' },
    { _id: '693291818ec00e5b1605bed2', name: 'Dry Fruits & Nuts', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766751985/products/nyk54xjlnerjgobfdgae.png' },
    { _id: '693295a48ec00e5b1605bf27', name: 'Superfoods', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752030/products/amcx65vs31ewwizoajyc.png' },
    { _id: '693296238ec00e5b1605bf2e', name: 'Beverages', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752340/products/nbtpvdcyfffse7xzunqq.png' },
    { _id: '693296618ec00e5b1605bf31', name: 'Natural Products', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752598/products/v9twecgy8l5chukiw9qw.png' },
    { _id: '6932a77801f804e9a3267247', name: 'Breakfast Essentials', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752378/products/pmaawk72mvs8ehzsty6r.png' },
    { _id: '6932a7d501f804e9a326724a', name: 'Combos & Gift Packs', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752496/products/nxbunwjsj8briwudyvpv.png' },
    { _id: '6932aac901f804e9a326726d', name: 'Immunity & Wellness', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766752579/products/qesw0zc598mv00gkwfbs.png' },
    { _id: '6932c61ac86f55cf811a5920', name: 'Protein Bar', image: 'https://res.cloudinary.com/dsjkjd3k4/image/upload/v1766751897/products/wdtx575dofasyi7fxcac.png' },
  ];

  const cartItemCount = cart.reduce((total, item) => total + (item.qty || 1), 0);
  const wishlistCount = wishlist.length;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsCategoryBarVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setIsCategoryBarVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://server.havbit.in/api/categories');
      if (response.ok) {
        const data = await response.json();
        setCategories(data);
      } else {
        setCategories(FALLBACK_CATEGORIES);
      }
      setLoading(false);
    } catch (error) {
      setCategories(FALLBACK_CATEGORIES);
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
      setSearchQuery("");
    }
  };

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    if (value.trim()) {
      navigate(`/search?q=${encodeURIComponent(value.trim())}`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };

  const handleCategoryClick = (category) => {
    if (location.pathname === "/") {
      setSelectedHomeCategory(category);
      return;
    }

    navigate(`/category/${category._id}`);
  };

  return (
    <>
      <header ref={headerRef} className="sticky top-0 z-50 bg-white shadow-sm">
        <div className="border-b border-gray-100">
          <div className="container mx-auto px-2 sm:px-4">
            <div className="flex items-center justify-between h-14 md:h-16">

              <div className="flex-shrink-0">
                <Link to="/" className="flex items-center">
                  <img src={logo} alt="Havbit" className="h-10 md:h-16 w-auto object-contain" />
                </Link>
              </div>

              <div className="hidden lg:flex flex-1 mx-8">
                <form onSubmit={handleSearch} className="relative w-full max-w-xl">
                  <div className="relative">
                    <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                    <input
                      type="text"
                      placeholder="Search for snacks, nuts, beverages..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e.target.value)}
                      className="w-full pl-12 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-red-400 text-sm"
                    />
                  </div>
                </form>
              </div>

              <div className="hidden lg:flex items-center space-x-3">
                <Link to="/wishlist" className="p-2 rounded-full hover:bg-gray-100 relative group">
                  <FiHeart size={22} className="text-gray-600 group-hover:text-red-400 transition-colors" />
                  {wishlistCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-400 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                      {wishlistCount}
                    </span>
                  )}
                </Link>
                <Link to="/cart" className="p-2 rounded-full hover:bg-gray-100 relative group">
                  <FiShoppingCart size={22} className="text-gray-600 group-hover:text-red-400 transition-colors" />
                  {cartItemCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-400 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                      {cartItemCount}
                    </span>
                  )}
                </Link>
                <Link to="/account" className="p-2 rounded-full hover:bg-gray-100 group">
                  <FiUser size={22} className="text-gray-600 group-hover:text-red-400" />
                </Link>
              </div>

              <div className="flex lg:hidden items-center space-x-1">
                <Link to="/search" className="p-2 text-gray-600 active:text-red-400">
                  <FiSearch size={20} />
                </Link>
                <Link to="/wishlist" className="p-2 text-gray-600 relative active:text-red-400">
                  <FiHeart size={20} />
                  {wishlistCount > 0 && (
                    <span className="absolute top-1 right-1 bg-red-400 text-white text-[8px] font-bold w-3.5 h-3.5 flex items-center justify-center rounded-full">
                      {wishlistCount}
                    </span>
                  )}
                </Link>
              </div>

            </div>
          </div>
        </div>
      </header>

      {/* ✅ ONLY SHOW ON HOME PAGE */}
      {location.pathname === '/' && (
        <motion.div
          initial={{ y: 0 }}
          animate={{ y: isCategoryBarVisible ? 0 : -100 }}
          transition={{ duration: 0.3 }}
          className="sticky z-40 bg-white shadow-sm border-b border-gray-100"
          style={{ top: '56px' }}
        >
          <div className="container mx-auto px-2">
            <div className="flex overflow-x-auto scrollbar-hide py-2 gap-2 lg:gap-4 items-center">
              <button onClick={() => { setSelectedHomeCategory(null); navigate('/'); }} className="flex-shrink-0 flex flex-col items-center min-w-[50px] lg:min-w-[80px]">
                <FiHome className="w-5 h-5 mb-1 text-gray-500" />
                <span className="text-[10px] lg:text-xs font-medium">Home</span>
              </button>

              {!loading && categories.map((category) => (
                <button key={category._id} onClick={() => handleCategoryClick(category)}
                  className="flex-shrink-0 flex flex-col items-center min-w-[55px] lg:min-w-[80px]">
                  <div className="w-6 h-6 lg:w-7 lg:h-7 mb-1 flex items-center justify-center">
                    <img src={category.image} alt={category.name} className="max-w-full max-h-full object-contain" />
                  </div>
                  <span className="text-[10px] lg:text-xs font-medium whitespace-nowrap">
                    {category.name}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
}